import React from 'react'
import { useSelector } from 'react-redux'
import { getSessionPolls } from '~/selectors/session-details'
import Poll from './poll'
import { NoBulletUl } from './styled'

const PollList = ({ id }) => {
  const polls = useSelector(getSessionPolls(id))

  return (
    <NoBulletUl>
      {polls.map(poll =>
        <Poll
          key={poll.id}
          {...poll}
        />)}
    </NoBulletUl>
  )
}

export default PollList
